export const secciones = {
  '1': 'NPS',
  '2': 'Reactivos',
  '3': 'Preguntas de control',
  '4': 'Demográficos',
  '5': 'Preguntas Abiertas',
  '6': 'Prácticas 4All',
  '7': 'Preguntas adicionales',
  '8': 'Reactivos NOM035',
}
export const preguntas = {
  '1': 'Opción múltiple (Radio)',
  '2': 'Pregunta abierta',
  '3': 'Reactivo',
  '4': 'Opción múltiple (Radio)',
  '5': 'Práctica 4All',
  '6': 'Opción múltiple (Check)',
  '7': 'Reactivo NOM035',
  '8': 'Audio',
}
export const abiertas = {
  '1': 'Texto abierto',
  '2': 'Texto numérico',
}
export const preguntasEspeciales = {
  '1': 'Pregunta normal',
  '2': 'Pregunta especial',
}
